import { render, staticRenderFns } from "./IssueItemModal.vue?vue&type=template&id=0ee400bf&scoped=true&"
import script from "./IssueItemModal.vue?vue&type=script&lang=js&"
export * from "./IssueItemModal.vue?vue&type=script&lang=js&"
import style0 from "./IssueItemModal.vue?vue&type=style&index=0&id=0ee400bf&lang=scss&scoped=true&"
import style1 from "./IssueItemModal.vue?vue&type=style&index=1&id=0ee400bf&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee400bf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ee400bf')) {
      api.createRecord('0ee400bf', component.options)
    } else {
      api.reload('0ee400bf', component.options)
    }
    module.hot.accept("./IssueItemModal.vue?vue&type=template&id=0ee400bf&scoped=true&", function () {
      api.rerender('0ee400bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/references/uniform-items/modals/IssueItemModal.vue"
export default component.exports